document.addEventListener('DOMContentLoaded',function(){

  let product = new Vue({
    el: '#app2',
    data(){
      return {
        newItemCSVPath: './data/new/newitem.csv',
        isMounted: false,
        today: new Date(),
        newItemProducts: [],
        displayCount: 2,
        moreBtn: document.querySelector('.newitem-more'),
        displayMoreBtn: true,
      }
    },
    watch: {
      displayCount: function(newNum){
        this.displayChange(newNum);
      }
    },
    computed: {
      allDates(){
        // 全発売日配列
        let dates = this.newItemProducts.map(item => item.date);
        dates = Array.from(new Set(dates));
        return dates;
      },
      displayLimitDate(){
        // 今日から６０日前発売のものまでは表示
        const date = new Date();
        date.setDate(date.getDate() - 60);
        return date;
      },
      newItemsDates(){
        // 発売日配列を日付データに変換
        let allDates = this.allDates.map(item => new Date(item));
        // 今日以前の日付のみ取得
        let dates = allDates.filter(date => date.getTime() <= this.today.getTime());
        // 60日前以降の日付のみ取得
        dates = dates.filter(date => date.getTime() >= this.displayLimitDate.getTime());
        dates = dates.map(date => date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate());
        return dates;
      },
      newItemsProducts(){
        let dates = [...this.newItemsDates];
        dates = dates.reverse();
        let newItemsProducts = [];
        for (let i = 0; i < dates.length; i++){
          newItemsProducts[i] = {
            'date': dates[i],
            // 'areaID': 'newItem' + dates[i].split('/').join(''),
            'displayDate': dates[i].slice(5).replace('/','.'),
            'display': (i < this.displayCount) ? true : false,
            'products': this.newItemProducts.filter(function(product){
              return product.date === dates[i];
            })
          };
        }
        return newItemsProducts
      },
    },
    mounted(){
      Promise.all([
        this.getCSV(this.newItemCSVPath)
      ]).then(function(values) {
        this.newItemProducts = values[0];
      });
      setTimeout(() => this.isMounted = true, 10);
    },
    methods: {
      async getCSV(CSVpath){
        const response = await fetch(CSVpath,{
          method: 'GET',
          mode: 'cors',
        });
        let data = await response.text();
        data = data.split('\r\n');
        const headers = data.shift().split(',');
        const rows = data;
        const arr = await rows.map(function(row) {
          const values = row.split(',');
          const el = headers.reduce(function(obj, header, i) {
            const value = values[i];
            obj[header] = value;
            return obj
          },{}
          );
          return el;
        });
        // console.log(CSVpath,arr);
        arr.map(function(item){
          item.taxinPrice = Number(item.taxinPrice).toLocaleString();
        })
        this.newItemProducts = arr;

        return arr;
      },
      displayChange(num){
        this.newItemsProducts.map(function(item, index){
          if (index < num) {
            item.display = true;
          }
        })
      },
      newItemMore(){
        this.displayCount++;
        if(this.newItemsDates.length == this.displayCount){
          this.displayMoreBtn = false;
        }
        const newItemsLoadEvent = new CustomEvent('loadMore');
        setTimeout(() => {
          document.body.dispatchEvent(newItemsLoadEvent);
        }, 10);
      },
      track(id, url){
        console.log(id)
        console.log(url);
        _sc.gene_click(id, url);
      },
    },
  });

});


window.addEventListener('load', function(){


});
